let language = null;

export const setLanguage = (value) => {
  language = value;
}

export const getLanguage = () => {
  return language;
}